import { FC, HTMLAttributes } from 'react'
import styles from 'components/features/future/FutureColorPicker/FutureColorPicker.styl'
import cn from 'classnames'

type FutureColorPickerProps =
  & HTMLAttributes<HTMLElement>
  & {
    type: 'assets' | 'debts'
    index?: number
  }

export const FutureColorPicker: FC<FutureColorPickerProps> = (props) => {
  const { index = 0, children, type, className, ...restProps } = props

  const colorClassName = `color${ index }` as keyof typeof styles
  const currentClassName = cn(
    styles.futureColorPicker,
    styles[type],
    styles[colorClassName] as string,
    className,
  )
  return (
    <div className={ currentClassName } { ...restProps }>
      { children }
    </div>
  )
}
